import {TabState, TabStateDefaults} from 'Navigation';

export default class RelevantItemsTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Relevant Items',
      closeable: false,
      preferenceKey: 'relevant-items-tab',
    };
  }
}
